module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0670.a1f8629c.jpg";